<template>
  <div class="admin-layout">
    <!-- 管理员顶部导航栏 -->
    <div class="admin-header">
      <v-app-bar app color="primary" dark>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>管理控制台</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="logout">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-app-bar>
    </div>

    <!-- 管理员侧边栏 -->
    <v-navigation-drawer v-model="drawer" app>
      <v-list>        <v-list-item
          v-for="(route, index) in adminRoutes"
          :key="index"
          :to="route.path"
          link
          exact
        >
          <v-list-item-icon>
            <v-icon>{{ route.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ route.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- 主内容区域 -->
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </div>
</template>

<script>
export default {
  name: 'AdminLayout',
  data () {
    return {
      drawer: true,
      adminRoutes: [
        { title: '控制台', path: '/admin/dashboard', icon: 'mdi-view-dashboard' },
        { title: '用户管理', path: '/admin/users', icon: 'mdi-account-group' },
        { title: '内容管理', path: '/admin/content', icon: 'mdi-text-box' },
        { title: '系统设置', path: '/admin/settings', icon: 'mdi-cog' }
      ]
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
